const filterData = [
  {
    id: 1,
    value: 'living',
    name: '홈/리빙',
  },
  {
    id: 2,
    value: 'business',
    name: '비즈니스',
  },

  {
    id: 3,
    value: 'coding',
    name: '개발/디자인',
  },
  {
    id: 4,
    value: 'pet',
    name: '반려동물',
  },

  {
    id: 5,
    value: 'lesson',
    name: '레슨',
  },
  {
    id: 6,
    value: 'health',
    name: '건강',
  },

  {
    id: 7,
    value: 'etc',
    name: '기타',
  },
];

const sortData = [
  {
    id: 'distance',
    name: '거리순',
  },

  {
    id: 'price',
    name: '가격낮은순',
  },
  {
    id: 'ratings',
    name: '별점순',
  },
  {
    id: 'review',
    name: '고용횟수순',
  },
];

export { filterData, sortData };
